<template>
    <header class="header header-component myecocar-theme">
        <IdentityValidationCountdownBanner />
        <div class="actionbar actionbar-top visible-xs myecocar-mobile-header">
            <div class="actionbar_section actionbar_icon">
                <span v-if="showLogo">
                    <router-link
                        :to="{ name: 'trips', params: { clearSearch: true } }"
                        v-on:click.native="tripsClick"
                    >
                        <img src="https://i.imgur.com/z198fac.png" alt="MyEcoCar" class="myecocar-mobile-logo" />
                    </router-link>
                </span>
                <template
                    v-else
                    v-for="item in leftHeaderButton"
                    :key="item.id"
                >
                    <span v-if="item.show" @click="onClick(item)">
                        <i :class="'fa ' + item.icon" aria-hidden="true"></i>
                    </span>
                </template>
            </div>
            <div
                class="actionbar_section actionbar_title"
                :class="subTitle !== '' ? 'header--with-subtitle' : ''"
            >
                <div
                    class="header--image circle-box"
                    v-imgSrc="imgTitle"
                    v-show="imgTitle"
                ></div>
                <span v-if="!titleLink.name" class="header--title">{{
                    title
                }}</span>
                <router-link
                    v-if="titleLink.name"
                    :to="{ name: titleLink.name, params: titleLink.params }"
                    class="header--title"
                >
                    <span>{{ title }}</span>
                </router-link>
                <span class="header--subtitle">{{ subTitle }}</span>
            </div>
            <div class="actionbar_section actionbar_icon pull-right">
                <template v-for="item in rightHeaderButton" :key="item.id">
                    <span v-if="item.show" @click="onClick(item)">
                        <i :class="'fa ' + item.icon" aria-hidden="true"></i>
                    </span>
                </template>
                <div class="dropdown-right" v-if="showMenu || isMobile">
                    <dropdown type="icon">
                        <template #button>
                            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                        </template>
                        <li>
                            <router-link tag="a" :to="{ name: 'acerca_de' }">
                                {{ $t('acercaDe') }}
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{ name: 'terms' }" tag="a">
                                {{ $t('tyc') }}
                            </router-link>
                        </li>
                        <li role="separator" class="divider"></li>
                        <li>
                            <a @click="setLocale('fr')">Français</a>
                        </li>
                        <li>
                            <a @click="setLocale('de')">Deutsch</a>
                        </li>
                        <li
                            v-if="user"
                            role="separator"
                            class="divider"
                        ></li>
                        <li v-if="user">
                            <a @click="logout" v-if="!isFacebokApp">{{
                                $t('cerrarSesion')
                            }}</a>
                        </li>
                    </dropdown>
                </div>
            </div>

            <div
                class="actionbar_section actionbar_icon pull-right"
                v-if="isMobile && user && !shouldHideDonationOnIOSCapacitor(user)"
            >
                <a
                    href="/donar"
                    class="btn btn-primary btn-donar-header btn-header-small btn-lg"
                >
                    {{ $t('donar') }}
                </a>
            </div>
            <div
                class="actionbar_section actionbar_icon pull-right"
                v-if="isMobile && !user"
            >
                <router-link
                    v-if="isTripsPage"
                    tag="a"
                    :to="{ name: 'login' }"
                    class="btn btn-primary btn-login-header btn-header-small btn-lg"
                >
                    Ingresar
                </router-link>
            </div>
        </div>
        <!-- Desktop Header - MyEcoCar Design -->
        <div class="header_content hidden-xs myecocar-header">
            <router-link
                :to="{ name: 'trips', params: { clearSearch: true } }"
                v-on:click.native="tripsClick"
                class="header_logo-link"
            >
                <div class="header_panel-left">
                    <img src="https://i.imgur.com/z198fac.png" alt="MyEcoCar" class="myecocar-logo" />
                    <span class="myecocar-brand-name">MyEcoCar</span>
                </div>
            </router-link>
            <div class="header_panel-right">
                <!-- Créer un trajet - Toujours visible -->
                <router-link
                    :to="{ name: 'new-trip' }"
                    class="btn btn-primary btn-lg myecocar-btn-primary"
                >
                    {{ $t('crearViaje') }}
                </router-link>

                <!-- Publier une demande - Toujours visible -->
                <router-link
                    :to="{ name: 'new-trip', query: { passenger: '1' } }"
                    class="btn btn-secondary btn-lg myecocar-btn-secondary"
                >
                    {{ $t('publierDemande') }}
                </router-link>

                <!-- Sélecteur de langue avec icône world -->
                <dropdown type="link" class="myecocar-lang-selector">
                    <template #button>
                        <i class="fa fa-globe" aria-hidden="true"></i>
                        <span class="lang-label">{{ currentLocaleShortLabel }}</span>
                    </template>
                    <li>
                        <a @click="setLocale('fr')">Français</a>
                    </li>
                    <li>
                        <a @click="setLocale('de')">Deutsch</a>
                    </li>
                </dropdown>

                <!-- Connexion - Si non connecté -->
                <router-link
                    v-if="!logged"
                    :to="{ name: 'login' }"
                    class="btn btn-link myecocar-btn-link"
                >
                    {{ $t('connexion') }}
                </router-link>

                <!-- S'inscrire - Si non connecté -->
                <router-link
                    v-if="!logged"
                    :to="{ name: 'register' }"
                    class="btn btn-link myecocar-btn-link"
                >
                    {{ $t('RegistrarNuevoUsuario') }}
                </router-link>

                <!-- Notifications - Si connecté -->
                <span
                    class="header_notifications myecocar-notifications"
                    @click="toNotifications"
                    v-if="logged"
                >
                    <span class="fa-container">
                        <i class="fa fa-bell" aria-hidden="true"></i>
                    </span>
                    <span class="badge" v-if="notificationsCount > 0">
                        {{ notificationsCount }}
                    </span>
                </span>

                <!-- Profil utilisateur - Si connecté -->
                <div class="header_profile myecocar-profile" v-if="logged && user">
                    <span class="user-name">{{ user.name }}</span>
                    <dropdown type="info">
                        <template #button>
                            <div
                                class="circle-box header_profile_image"
                                v-imgSrc:profile="user.image"
                            ></div>
                        </template>
                        <li>
                            <router-link :to="{ name: 'my-trips' }">
                                {{ $t('misViajes') }}
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{ name: 'conversations-list' }">
                                {{ $t('mensajes') }}
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{ name: 'profile', params: { id: 'me' } }">
                                {{ $t('perfil') }}
                            </router-link>
                        </li>
                        <li v-if="user.is_admin">
                            <router-link :to="{ name: 'admin-page' }">
                                {{ $t('administracion') }}
                            </router-link>
                        </li>
                        <li role="separator" class="divider"></li>
                        <li>
                            <a @click="logout" v-if="!isFacebokApp">{{
                                $t('cerrarSesion')
                            }}</a>
                        </li>
                    </dropdown>
                </div>
            </div>
            <div class="cf"></div>
        </div>
    </header>
</template>

<script>
import { mapGetters } from 'vuex';
import dropdown from '../Dropdown';
import router from '../../router';
import bus from '../../services/bus-event.js';
import modal from '../Modal';
import IdentityValidationCountdownBanner from '../IdentityValidationCountdownBanner.vue';
import { shouldHideDonationOnIOSCapacitor } from '../../services/capacitor.js';

export default {
    name: 'headerApp',

    data() {
        return {
            background_desktop_mini:
                process.env.ROUTE_BASE +
                'static/img/' +
                process.env.TARGET_APP +
                '_background_desktop_mini.png',
            background_desktop:
                process.env.ROUTE_BASE +
                'static/img/' +
                process.env.TARGET_APP +
                '_background_desktop.png',
            app_logo:
                process.env.ROUTE_BASE +
                'static/img/' +
                process.env.TARGET_APP +
                '_logo.png',
            showModal: false,
            shareUrl: encodeURIComponent(new URL(process.env.WEB_URL).origin)
        };
    },

    mounted() {
        bus.on('header-title-change', this.onHeaderChange);
        console.log('app_logo', this.app_logo);
        console.log('ROUTE_BASE', process.env.ROUTE_BASE);
    },

    computed: {
        ...mapGetters({
            logged: 'auth/checkLogin',
            user: 'auth/user',
            notificationsCount: 'notifications/count',
            title: 'actionbars/title',
            titleLink: 'actionbars/titleLink',
            subTitle: 'actionbars/subTitle',
            imgTitle: 'actionbars/imgTitle',
            showMenu: 'actionbars/showMenu',
            leftHeaderButton: 'actionbars/leftHeaderButton',
            rightHeaderButton: 'actionbars/rightHeaderButton',
            logoHeaderVisibility: 'actionbars/headerLogoVisibility',
            isNotLargeDesktop: 'device/isNotLargeDesktop',
            isFacebokApp: 'device/isFacebokApp',
            isMobile: 'device/isMobile',
            config: 'auth/appConfig'
        }),

        showLogo() {
            for (let i = 0; i < this.leftHeaderButton.length; i++) {
                if (this.leftHeaderButton[i].show) {
                    return false;
                }
            }
            return true;
        },
        isTripsPage() {
            return this.$route.name === 'trips';
        },
        currentLocaleLabel() {
            const labels = { fr: 'Français', de: 'Deutsch' };
            return labels[this.$i18n.locale] || 'Français';
        },
        currentLocaleShortLabel() {
            const short = { fr: 'FR', de: 'DE' };
            return short[this.$i18n.locale] || 'FR';
        }
    },

    methods: {
        shouldHideDonationOnIOSCapacitor(user) {
            return shouldHideDonationOnIOSCapacitor(user);
        },
        share() {
            // dialogs.message('Message example');
            /* if (window && window.plugins && window.plugins.socialsharing && window.plugins.socialsharing.shareWithOptions) {
                socialShare.share();
            } else {
                this.showModal = true;
            } */
            // Primero necesito ver cuando estoy en App y cuando en Web
            this.showModal = true;
        },

        logout() {
            this.$store.dispatch('auth/logout');
        },

        toNotifications() {
            router.push({ name: 'notifications' });
        },

        onClick(item) {
            bus.emit(item.id + '-click');
        },

        tripsClick() {
            this.$store.dispatch('trips/refreshList', true);
            this.$store.dispatch('trips/tripsSearch', { is_passenger: false });
        },

        onHeaderChange() {
            // console.log('header-change', this.title);
        },

        setLocale(locale) {
            this.$root.$i18n.locale = locale;
            localStorage.setItem('app_locale', locale);
        }
    },
    watch: {
        title(_old, _new) {
            console.log('titlee change', this.title);
        }
    },
    components: {
        dropdown,
        modal,
        IdentityValidationCountdownBanner
    }
};
</script>

<style scoped>
/* MyEcoCar Header Styles */
.myecocar-header {
    background: linear-gradient(to right, #e8f5e9 0%, #c8e6c9 100%);
    padding: 10px 40px;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    font-family: 'Heebo', sans-serif;
    border-bottom: 1px solid rgba(89, 195, 98, 0.1);
    flex-wrap: nowrap !important;
}

.header_logo-link {
    text-decoration: none;
    display: flex !important;
    align-items: center !important;
    transition: opacity 0.3s ease;
    flex-shrink: 0 !important;
}

.header_logo-link:hover {
    opacity: 0.85;
}

.header_panel-left {
    display: flex !important;
    align-items: center !important;
    gap: 15px;
    padding: 5px 10px;
    border-radius: 8px;
    transition: background-color 0.3s ease;
    flex-shrink: 0 !important;
}

.header_panel-left:hover {
    background-color: rgba(89, 195, 98, 0.05);
}

.myecocar-logo {
    height: 42px;
    width: auto;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.myecocar-brand-name {
    font-size: 24px;
    font-weight: 700;
    color: var(--primary-color);
    font-family: 'Heebo', sans-serif;
    letter-spacing: -0.5px;
}

.header_panel-right {
    display: flex !important;
    align-items: center !important;
    gap: 8px;
    flex: 1 !important;
    justify-content: flex-end !important;
    padding-left: 20px;
    flex-wrap: nowrap !important;
    margin-left: auto !important;
}

/* Boutons MyEcoCar */
.myecocar-btn-primary {
    background: linear-gradient(135deg, var(--primary-color) 0%, #4ab359 100%) !important;
    border: none !important;
    color: white !important;
    font-weight: 600;
    padding: 10px 20px;
    border-radius: 10px;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(89, 195, 98, 0.25);
    font-size: 14px;
}

.myecocar-btn-primary:hover {
    background: linear-gradient(135deg, #4ab359 0%, var(--primary-color) 100%) !important;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(89, 195, 98, 0.4);
}

.myecocar-btn-secondary {
    background: linear-gradient(135deg, var(--secondary-color) 0%, #628a6f 100%) !important;
    border: none !important;
    color: white !important;
    font-weight: 600;
    padding: 10px 20px;
    border-radius: 10px;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(113, 153, 125, 0.25);
    font-size: 14px;
}

.myecocar-btn-secondary:hover {
    background: linear-gradient(135deg, #628a6f 0%, var(--secondary-color) 100%) !important;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(113, 153, 125, 0.4);
}

.myecocar-btn-link {
    color: var(--main-font-color) !important;
    font-weight: 800;
    padding: 8px 14px;
    transition: all 0.3s ease;
    border-radius: 8px;
    font-size: 14px;
    background-color: transparent;
    border: 2px solid transparent;
}

.myecocar-btn-link:hover {
    color: var(--primary-color) !important;
    text-decoration: none;
    background-color: rgba(89, 195, 98, 0.08);
    border-color: rgba(89, 195, 98, 0.2);
}

/* Sélecteur de langue */
.myecocar-lang-selector {
    margin-left: 0;
    margin-right: 0;
}

.myecocar-lang-selector .btn {
    color: var(--main-font-color);
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    padding: 10px 12px;
    border-radius: 8px;
    transition: all 0.3s ease;
    background-color: rgba(89, 195, 98, 0.05);
    border: 2px solid transparent;
}

.myecocar-lang-selector .btn:hover {
    background-color: rgba(89, 195, 98, 0.12);
    border-color: rgba(89, 195, 98, 0.2);
    color: var(--primary-color);
}

.myecocar-lang-selector .fa-globe {
    font-size: 20px;
    color: var(--primary-color);
}

.lang-label {
    font-weight: 600;
    font-size: 18px;
    color: rgb(105, 102, 98);
}

/* Notifications */
.myecocar-notifications {
    position: relative;
    cursor: pointer;
    color: var(--main-font-color);
    font-size: 20px;
    padding: 5px 8px;
    width: 50px;
    max-height: 60px;
    transition: all 0.3s ease;
    border-radius: 8px;
    background: linear-gradient(135deg, rgba(44, 71, 46, 0.349) 0%, rgba(54, 109, 58, 0.281) 100%);
    margin-left: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.myecocar-notifications:hover {
    color: var(--primary-color);
    background: linear-gradient(135deg, rgba(89, 195, 98, 0.15) 0%, rgba(89, 195, 98, 0.1) 100%);
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(89, 195, 98, 0.2);
}

.myecocar-notifications .badge {
    position: absolute;
    top: 2px;
    right: 2px;
    background: linear-gradient(135deg, #ff3333 0%, #D72521 100%);
    color: white;
    border-radius: 10px;
    padding: 2px 5px;
    font-size: 10px;
    font-weight: 700;
    border: 2px solid white;
    box-shadow: 0 2px 4px rgba(215, 37, 33, 0.5);
    min-width: 18px;
    text-align: center;
}

/* Profil utilisateur */
.myecocar-profile {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0px 10px;
    max-height: 70px;
    border-radius: 10px;
    transition: all 0.3s ease;
    background: linear-gradient(135deg, rgba(44, 71, 46, 0.349) 0%, rgba(54, 109, 58, 0.281) 100%);
    margin-left: 6px;
    border: 1px solid transparent;
    justify-content: center;
}

.myecocar-profile:hover {
    background: linear-gradient(135deg, rgba(89, 195, 98, 0.15) 0%, rgba(89, 195, 98, 0.1) 100%);
    border-color: rgba(89, 195, 98, 0.2);
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(89, 195, 98, 0.2);
}

.myecocar-profile .user-name {
    font-weight: 600;
    color: var(--main-font-color);
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
}

.header_profile_image {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: 2px solid var(--primary-color);
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 6px rgba(89, 195, 98, 0.25);
}

.header_profile_image:hover {
    transform: scale(1.08);
    border-color: #4ab359;
    box-shadow: 0 3px 10px rgba(89, 195, 98, 0.4);
}

/* Legacy styles */
.trips-link {
    font-weight: bold;
}
.actionbar_icon img {
    margin-bottom: 2px;
    width: 26px;
    margin-left: 0.3em;
}

/* Responsive Design */
@media (max-width: 1200px) {
    .header_panel-right {
        gap: 10px;
    }
    
    .myecocar-btn-primary,
    .myecocar-btn-secondary {
        padding: 10px 18px;
        font-size: 14px;
    }
    
    .myecocar-btn-link {
        padding: 8px 14px;
        font-size: 14px;
    }
    
    .myecocar-brand-name {
        font-size: 24px;
    }
    
    .myecocar-logo {
        height: 44px;
    }
}

@media (max-width: 1050px) {
    .myecocar-header {
        padding: 12px 25px;
    }
    
    .header_panel-right {
        gap: 8px;
    }
    
    .myecocar-btn-primary,
    .myecocar-btn-secondary {
        padding: 9px 16px;
        font-size: 13px;
    }
    
    .myecocar-btn-link {
        padding: 8px 12px;
        font-size: 13px;
    }
    
    .myecocar-profile .user-name {
        max-width: 100px;
    }
}

@media (max-width: 900px) {
    .myecocar-header {
        padding: 10px 20px;
    }
    
    .myecocar-brand-name {
        font-size: 20px;
    }
    
    .myecocar-logo {
        height: 38px;
    }
    
    .header_panel-right {
        gap: 6px;
    }
    
    .myecocar-btn-primary,
    .myecocar-btn-secondary,
    .myecocar-btn-link {
        padding: 8px 12px;
        font-size: 12px;
    }
    
    .myecocar-profile .user-name {
        display: none;
    }
}

/* Mobile Header Styles */
.myecocar-mobile-header {
    background-color: var(--header-background) !important;
    font-family: 'Heebo', sans-serif;
}

.myecocar-mobile-logo {
    height: 35px;
    width: auto;
}

.myecocar-theme .actionbar-top {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.myecocar-theme .btn-primary {
    background-color: var(--primary-color) !important;
    border-color: var(--primary-color) !important;
}

.myecocar-theme .btn-primary:hover {
    background-color: #4ab359 !important;
}

.myecocar-theme .actionbar_icon i {
    color: var(--primary-color);
}
</style>
